import { ChipList } from '../../../components/ChipList';
import { useOperator } from '../../../contexts/OperatorContext';
import { ReviewItems } from './ReviewItems';
import { Select } from '../../../components/Select/Select';
import { Label } from '../../../components/Label';
import { Option } from '../../../components/Option';

export const Packages = (
  props: Omit<CreateAccountPackagesProps, 'onChange'>
) => {
  const { asReview, formValues, optionMenus, updateFormState } = props;
  const operator = useOperator();

  const addOnPackages = (operator.packages ?? []).filter(
    (p) => p.type === 'addons' && p.active
  );
  const alacartePackages = (operator.packages ?? []).filter(
    (p) => p.type === 'alaCarte' && p.active
  );

  const handlePackageChange = (
    addedPackages: string[],
    removedPackages: string[]
  ) => {
    updateFormState({
      subscriberGroupIDs: [
        ...addedPackages,
        ...formValues.subscriberGroupIDs.filter(
          (p) => !addedPackages.includes(p) && !removedPackages.includes(p)
        ),
      ],
    });
  };

  const handleBasePackage = (value: string) => {
    updateFormState({ basePackage: value });
  };

  return (
    <div className="flex flex-col items-start justify-start h-full gap-6 p-4">
      {asReview ? (
        <ReviewItems
          items={[
            {
              defaultValue: 'N/A',
              label: 'Base Package',
              required: true,
              value:
                optionMenus.basePackages.find(
                  (p) => p.id === formValues.basePackage
                )?.name ?? '',
            },
          ]}
        />
      ) : (
        <div className="max-w-[300px]">
          <Label className="w-full" text="Base Package" required>
            <Select
              name="basePackage"
              onChange={handleBasePackage}
              value={formValues.basePackage}
              variant="contained"
              fullWidth
            >
              {optionMenus.basePackages.map((option) => (
                <Option key={option.id} value={option.id}>
                  {option.name}
                </Option>
              ))}
            </Select>
          </Label>
        </div>
      )}
      <div className="flex flex-col">
        <Label text="Add-On Packages">
          <ChipList
            allItems={(operator.packages ?? [])
              .filter((p) => p.type === 'addons' && p.active)
              .map((p) => ({ id: p.id, name: p.description }))}
            editing={!asReview}
            existingItems={addOnPackages.filter((p) => {
              if (formValues.subscriberGroupIDs.includes(p.id))
                return {
                  id: p.id,
                  name: p.description,
                };
            })}
            onChange={handlePackageChange}
            saveRequired={false}
            noItemsMessage="None"
          />
        </Label>
      </div>
      {(operator.packages as ResAccountSubscriberGroup[]).filter(
        (p) => p.type === 'alaCarte'
      ).length ? (
        <div className="flex flex-col">
          <Label text="À La Carte Packages">
            <ChipList
              allItems={(operator.packages as ResAccountSubscriberGroup[])
                .filter((p) => p.type === 'alaCarte' && p.active)
                .map((p) => ({ id: p.id, name: p.description }))}
              editing={!asReview}
              existingItems={alacartePackages.filter((p) => {
                if (formValues.subscriberGroupIDs.includes(p.id))
                  return {
                    id: p.id,
                    name: p.description,
                  };
              })}
              noItemsMessage="None"
              onChange={handlePackageChange}
              saveRequired={false}
            />
          </Label>
        </div>
      ) : null}
    </div>
  );
};
